import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { FormErrorsModule, PageComponentModule, PageLayoutModule, PageSlotModule } from '@spartacus/storefront';

import { KnBrMyQuoteSearchComponent } from './kn-br-my-quote-search.component';

@NgModule({
  declarations: [KnBrMyQuoteSearchComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    UrlModule,
    I18nModule,
    FormErrorsModule,
    NgSelectModule,
    NgbTooltipModule,
    PageComponentModule,
    PageLayoutModule,
    PageSlotModule,
    ConfigModule.withConfig({
      cmsComponents: {
        KnBrStep2CustomerQuoteSearchComponent: {
          component: () => import('./kn-br-my-quote-search.component').then((c) => c.KnBrMyQuoteSearchComponent),
        },
      },
    } as CmsConfig),
  ],
  exports: [KnBrMyQuoteSearchComponent],
})
export class KnBrMyQuoteSearchModule {}
